import * as _ from 'lodash';
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { UserService } from '../../../../core/services/core.user.service';
import { StateStackService } from '../../../../core/services/core.state-stack.service';
import { StateService } from '@uirouter/angular';
import { SiteConfigService } from '../../../../core/services/core.site-config.service';
import { buildTrackerMacroContext, expandTrackerMacros } from '../../services/tracker.macro.functions';

@Component({
    selector: 'trackeritem-add-toolbar',
    template: require('./trackeritem.add.toolbar.component.html')
})
export class TrackerItemAddToolbarComponent implements OnInit {
    @Input() trackeritem: any;
    @Input() tracker: any;
    @Input() acls: any;
    @Input() members: any;
    @Input() isTopPosition: boolean;

    @Output() onSave: EventEmitter<any> = new EventEmitter<any>();

    submitText: any;
    monitoring: boolean;
    allowAssignment: boolean = true;
    aclInternal: any = {};

    constructor(
        private userService: UserService,
        private stateStackService: StateStackService,
        protected stateService: StateService,
        private siteConfigService: SiteConfigService
    ) {}

    /**
     * Expands the project-scoped macros an admin may have used in the tracker's
     * instruction text. Item-scoped macros (%URL%, %FIELDS_CHANGED%, ...) are
     * left as-is: no single tracker item is in scope on this screen.
     */
    private expandInstructions(text: string): string {
        const siteName = _.get(this.siteConfigService.getSiteConfig(), 'siteName', '');
        const context = buildTrackerMacroContext(
            this.tracker,
            siteName,
            (state: string, params: any) => this.stateService.href(state, params, { inherit: false }),
        );
        return expandTrackerMacros(text, context);
    }


    ngOnInit() {
        this.isTopPosition = typeof this.isTopPosition === 'boolean' ? this.isTopPosition : true;

        if (this.tracker?.submitInstructions ?? null) {
            this.submitText = {
                type: 'markdown',
                title: this.tracker.trackerName,
                glyph: 'glyphicon-info-sign',
                content: this.expandInstructions(this.tracker.submitInstructions)
            };
        }

        if (_.get(this.tracker, 'autoAssignToRoles[0]', null)) {
            this.allowAssignment = false;
            this.aclInternal = {
                canAssign: false,
                allowUpdates: false,
            }
        } else {
            this.allowAssignment = true;
            this.aclInternal = this.acls;
        }
    }

    hasAssignees() {
        const assignees: any = _.get(this.trackeritem, 'rel.assignees', []);
        return assignees.length > 0 && assignees[0].unixName !== this.userService.constants.nobody.unixName;
    }

    toggleMonitor() {
        this.monitoring = this.monitoring ? false : true;
    }

    showPrint() {
        window.print();
    }

    setLockStatus(lockStatus) {
        this.trackeritem.lockStatus = lockStatus;
    }

    save(nextLocation?: any) {
        this.onSave.emit({
            trackeritem: this.trackeritem, 
            nextLocation: nextLocation === true // nextLocation is true when "Save & New"
        });
    }

    doCancel(e?: any) {
        if (!_.isEmpty(e)) {
            e.preventDefault();
        }
        this.stateStackService.back('home.project.summary.tracker.browse', this.stateService.params);
    }
}
